export default function AgencyRevenueIcon({ color = '#195EFF' }: { color?: string }) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_39339_94282'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_39339_94282)'>
        <path
          d='M21.5039 6.30775V17.6923C21.5039 18.1974 21.3289 18.625 20.9789 18.975C20.6289 19.325 20.2013 19.5 19.6962 19.5H4.31166C3.80649 19.5 3.37891 19.325 3.02891 18.975C2.67891 18.625 2.50391 18.1974 2.50391 17.6923V6.30775C2.50391 5.80258 2.67891 5.375 3.02891 5.025C3.37891 4.675 3.80649 4.5 4.31166 4.5H19.6962C20.2013 4.5 20.6289 4.675 20.9789 5.025C21.3289 5.375 21.5039 5.80258 21.5039 6.30775ZM4.00391 8.404H20.0039V6.30775C20.0039 6.23075 19.9718 6.16025 19.9077 6.09625C19.8437 6.03208 19.7732 6 19.6962 6H4.31166C4.23466 6 4.16416 6.03208 4.10016 6.09625C4.03599 6.16025 4.00391 6.23075 4.00391 6.30775V8.404ZM4.00391 11.596V17.6923C4.00391 17.7692 4.03599 17.8398 4.10016 17.9038C4.16416 17.9679 4.23466 18 4.31166 18H19.6962C19.7732 18 19.8437 17.9679 19.9077 17.9038C19.9718 17.8398 20.0039 17.7692 20.0039 17.6923V11.596H4.00391Z'
          fill={color}
        />
      </g>
    </svg>
  );
}
